import React, { forwardRef, ReactNode } from 'react';

interface GlowCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glow?: boolean;
}

/** Glassmorphic card with optional glow — ported from the IQ Verity prototype. */
const GlowCard = forwardRef<HTMLDivElement, GlowCardProps>(
  ({ children, className = '', hover = true, glow = false, ...props }, ref) => {
    const cls = [
      'vr-card vr-glass-strong',
      hover ? 'vr-glow-border-hover' : '',
      glow ? 'vr-glow-border vr-animate-pulse-glow' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ');
    return (
      <div ref={ref} className={cls} {...props}>
        {children}
      </div>
    );
  }
);

GlowCard.displayName = 'GlowCard';

export default GlowCard;
